<template>
  <div class="contributor panel panel-default">
    <div class="panel-body">
      <div v-if="noContributorFields">
        {{ lang.get('entries.form.no-contributor-fields') }}
      </div>
      <draggable-fields
        :fields="contributorFields(tab.id)"
        :visible-fields="visibleContributorFields(tab.id, contributor)"
        resource-name="Contributors"
        :resource="contributor"
        :tab="tab"
        :lock-tabs="true"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import DraggableFields from './DraggableFields';

export default {
  inject: ['lang'],
  components: {
    DraggableFields
  },
  props: {
    tab: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters('entryForm', [
      'contributors',
      'contributorFields',
      'visibleContributorFields'
    ]),
    contributor() {
      return {
        id: 1,
        fields: this.contributorFields(this.tab.id)
      };
    },
    noContributorFields() {
      return this.contributorFields(this.tab.id).length === 0;
    }
  }
};
</script>
